var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-ads"},[_c('Search',{on:{"filter-ads":_vm.applyFilters}}),_c('a-g-speakol-table',{ref:"systemAdsTable",attrs:{"filters":_vm.agFilters,"columns":_vm.agColumns,"options":_vm.agOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }